<template>
    <div class="mt-2">
        <!-- <star-rating v-model="params.data.rate" :star-size="30" :show-rating="false" :read-only="true" :border-width="0" active-color="#EEEE00"></star-rating> -->
        <awesome-vue-star-rating :star="params.data.rate" disabled :maxstars="5" starsize="lg" :hasresults="false"
                                 :hasdescription="false" class="-mt-3"></awesome-vue-star-rating>
    </div>
</template>

<script>

// import StarRating from 'vue-star-rating';
import AwesomeVueStarRating from "awesome-vue-star-rating";

export default {
    components: {
        // StarRating,
        AwesomeVueStarRating
    },
}
</script>
